import { render, staticRenderFns } from "./_VpcStatusLabel.vue?vue&type=template&id=fa9ee02a"
import script from "./_VpcStatusLabel.vue?vue&type=script&lang=ts"
export * from "./_VpcStatusLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports